define((require) => {
    "use strict";

    const IntegrationModel = require("editor/ui/settings/integrations/IntegrationModel");

    /**
     * Marker class for Thumbnails genereated via CNC integration.
     *
     * @class ThumbnailsNativeContentIntegration
     */
    return IntegrationModel.extend("ThumbnailsNativeContentIntegration", {}, {
        type: "ThumbnailsNativeContentIntegration"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/settings/integrations/ThumbnailsNativeContentIntegrationModel.js